import { mapValues } from 'lodash/fp';
import { createSelector } from 'reselect';
import {
  allGeographiesUsdata,
  allIndicatorsUsdata,
} from '../basic';
import { denormalize } from './';

export default createSelector(
  allGeographiesUsdata,
  allIndicatorsUsdata,
  (geography, indicator) =>
    mapValues(denormalize, { geography, indicator })
);



// WEBPACK FOOTER //
// ./app/selectors/navigation/usdata.js